<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ message | translate }}</p>
  @if (itemValue) {
    <div class="rounded border bg-light-subtle p-3">
      @if (itemLabel) {
        <div class="small text-muted mb-1">
          @if (itemLabelTranslate) {
            {{ itemLabel | translate }}
          } @else {
            {{ itemLabel }}
          }
        </div>
      }
      <div class="fw-semibold">
        @if (itemValueTranslate) {
          {{ asTranslatedText(itemValue) | translate }}
        } @else if (itemValueRenderAsHtml) {
          <span [innerHTML]="itemValue"></span>
        } @else {
          {{ itemValue }}
        }
      </div>

      @if (details.length > 0) {
        <div class="mt-3">
          @for (detail of details; track $index) {
            <div class="small mb-2">
              <div class="text-muted">
                @if (detail.translateLabel) {
                  {{ detail.label | translate }}
                } @else {
                  {{ detail.label }}
                }
              </div>
              <div>
                @if (detail.translateValue) {
                  {{ asTranslatedText(detail.value) | translate }}
                } @else if (detail.renderValueAsHtml) {
                  <span [innerHTML]="detail.value"></span>
                } @else {
                  {{ detail.value }}
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismiss()">{{ cancelLabel | translate }}</button>
  <button type="button" class="btn {{ confirmButtonClass }}" (click)="confirm()">{{ confirmLabel | translate }}</button>
</div>
